import {
  CURRENT_AFFILIATE,
  getItemFromLocalStorage
} from 'shared/utils/local-storage';
import { http } from '../utils/axios';
import { IPatientConversation } from 'shared/interfaces/conversation.interface';

class PatientConversationService {
  private static instance: PatientConversationService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PatientConversationService {
    if (!PatientConversationService.instance) {
      PatientConversationService.instance = new PatientConversationService();
    }

    return PatientConversationService.instance;
  }

  getChannels = async ({ patientId }: { patientId: string }) => {
    const currentAffiliate = getItemFromLocalStorage(CURRENT_AFFILIATE);
    const { data } = await http<IPatientConversation>({
      url: `/patientConversations/getByPatient/${patientId}?affiliate=${currentAffiliate}`,
      method: 'GET'
    });
    return data;
  };

  sendMessage = async ({
    message,
    patientId,
    channelType = 'clinical'
  }: {
    message: string;
    patientId: string;
    channelType?: string;
  }) => {
    const { data } = await http<IPatientConversation>({
      url: `/patientConversations/${patientId}/sendMessage`,
      method: 'POST',
      data: {
        sender: 'patient',
        channelType,
        message
      }
    });
    return data;
  };

  getUnreadCount = async () => {
    const affiliateId = getItemFromLocalStorage(CURRENT_AFFILIATE);
    const { data } = await http<{ unread_count: number }>({
      url: `/patientConversations/actions/getMyUnreadCount?affiliate=${affiliateId}`,
      method: 'GET'
    });
    return data;
  };
}

const instance = PatientConversationService.getInstance();

export default instance;
